import store from "../../store";
import { uiActions } from "../../store/ui/ui-slice";
import { defaultAxios } from "../../utils/api/axios";
import showToast from "../../utils/toastUtil";

export const getAxios = async (url, params) => {
  try {
    const data = await defaultAxios.get(url, { params });
    console.log("🚀 ~ getAxios ~ data:", data);
    if (data?.success && data?.data) {
      return data?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("🚀 ~ getAxios ~ error:", error);
    throw error;
  }
};

export const putAxios = async (url, payload, toast = true) => {
  try {
    const response = await defaultAxios.put(url, payload);
    if (toast) showToast.success(response?.message || "Updated");
    return response;
  } catch (error) {
    if (toast) showToast.error(error?.message || "Failed");
    console.log("putAxios failed", error);
    return error;
  }
};

export const postAxios = async (url, payload, toast = true) => {
  try {
    const response = await defaultAxios.post(url, payload);
    if (toast) showToast.success(response?.message || "Created");
    return response;
  } catch (error) {
    console.log("🚀 ~ postAxios ~ error:", error);
    if (toast) showToast.error(error?.message || "Failed");
    console.log("postAxios failed", error?.message);
    return error;
  }
};

export const deleteAxios = async (url, payload, toast = true) => {
  try {
    const response = await defaultAxios.delete(url, {
      data: payload,
    });
    if (toast) showToast.success(response?.message || "Deleted");

    return response;
  } catch (error) {
    if (toast) showToast.error(error?.message || "Failed");
    console.log("deleteAxios failed", error);
    return error;
  }
};

export const patchAxios = async (url, payload, toast = true) => {
  try {
    const response = await defaultAxios.patch(url, payload);
    if (toast) showToast.success(response?.message || "Updated");

    return response;
  } catch (error) {
    if (toast) showToast.error(error?.message || "Failed");
    console.log("patchAxios failed", error);
    return error;
  }
};

export const getAxiosForAuthResponse = async (url, params) => {
  try {
    const data = await defaultAxios.get(url, { params });

    if (data && data?.success) {
      return data?.data;
    } else {
      return false;
    }
  } catch (error) {
    console.log("getAxiosForAuthResponse failed", error);
    return false;
  }
};
